import { supabase } from "@/integrations/supabase/client";
import { handleSupabaseFunctionError } from "@/utils/supabaseFunctionsError";
import type {
  GetSucursaleUeParams,
  GetSucursaleUeResponse,
} from "@/api/types/sucursaleUe";

export async function getSucursaleUe(
  params: GetSucursaleUeParams
): Promise<GetSucursaleUeResponse> {
  const { data, error } = await supabase.functions.invoke(
    `api/firma/sucursale?cui=${encodeURIComponent(params.cui)}`,
    { method: "GET" }
  );

  await handleSupabaseFunctionError(error);
  return data;
}
